import React from 'react';
function VisaLogo({
  dark
}: {
  dark?: boolean;
}) {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-350">
      <span className="font-extrabold italic text-[#1A1F71] text-lg tracking-tight" data-id="element-351">
        VISA
      </span>
    </div>;
}
function MastercardLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-0 min-w-[60px] h-10 shadow-sm" data-id="element-352">
      <span className="w-5 h-5 rounded-full bg-[#EB001B] -mr-1.5" data-id="element-353"></span>
      <span className="w-5 h-5 rounded-full bg-[#F79E1B] opacity-90 mix-blend-multiply" data-id="element-354"></span>
    </div>;
}
function AmexLogo() {
  return <div className="bg-[#006FCF] border border-[#006FCF] rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-355">
      <span className="font-extrabold text-white text-[10px] leading-tight text-center tracking-tight" data-id="element-356">
        AMERICAN
        <br data-id="element-357" />
        EXPRESS
      </span>
    </div>;
}
function PayPalLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center min-w-[60px] h-10 shadow-sm" data-id="element-358">
      <span className="font-extrabold italic text-lg leading-none" data-id="element-359">
        <span className="text-[#003087]" data-id="element-360">Pay</span>
        <span className="text-[#009CDE]" data-id="element-361">Pal</span>
      </span>
    </div>;
}
function ApplePayLogo() {
  return <div className="bg-black border border-black rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-362">
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white" aria-hidden="true" data-id="element-363">
        <path d="M17.5 12.5c0-2.5 2-3.7 2.1-3.8-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.6.9-.8 0-1.9-.9-3.1-.8-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.6.8 1.2 1.7 2.5 3 2.4 1.2-.1 1.7-.8 3.1-.8s1.9.8 3.1.7c1.3 0 2.1-1.2 2.9-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.6-3.5zM15.1 5.3c.7-.8 1.1-1.9 1-3-.9.1-2.1.6-2.7 1.4-.6.7-1.2 1.8-1 2.9 1 .1 2-.5 2.7-1.3z" data-id="element-364" />
      </svg>
      <span className="font-bold text-white text-xs" data-id="element-365">Pay</span>
    </div>;
}
function GooglePayLogo() {
  return <div className="bg-white border border-gray-200 rounded-md px-3 py-2 flex items-center justify-center gap-1 min-w-[60px] h-10 shadow-sm" data-id="element-366">
      <span className="font-extrabold text-xs leading-none" data-id="element-367">
        <span className="text-[#4285F4]" data-id="element-368">G</span>
        <span className="text-[#EA4335]" data-id="element-369">o</span>
        <span className="text-[#FBBC04]" data-id="element-370">o</span>
        <span className="text-[#4285F4]" data-id="element-371">g</span>
        <span className="text-[#34A853]" data-id="element-372">l</span>
        <span className="text-[#EA4335]" data-id="element-373">e</span>
      </span>
      <span className="font-bold text-gray-700 text-xs" data-id="element-374">Pay</span>
    </div>;
}
interface PaymentMethodsProps {
  label?: string;
  labelClassName?: string;
  className?: string;
}
export function PaymentMethods({
  label = 'We Accept',
  labelClassName = 'text-xs uppercase tracking-[0.25em] text-[#3E2723]/60 font-bold text-center mb-5',
  className = ''
}: PaymentMethodsProps) {
  return <div className={className} data-id="element-375">
      {label && <div className={labelClassName} data-id="element-376">{label}</div>}
      <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-377">
        <VisaLogo data-id="element-378" />
        <MastercardLogo data-id="element-379" />
        <AmexLogo data-id="element-380" />
        <PayPalLogo data-id="element-381" />
        <ApplePayLogo data-id="element-382" />
        <GooglePayLogo data-id="element-383" />
      </div>
    </div>;
}